<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title" />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  mounted() {
    this.getWebTool();

    // 将session更新到store
    if (sessionStorage.getItem("userInfo")) {
      this.$store.commit(
        "userInfoChange",
        JSON.parse(sessionStorage.getItem("userInfo"))
      );
      this.$store.commit("loginStateChange", 1);
    }

    // 将session更新到store
    if (sessionStorage.getItem("examId")) {
      this.$store.commit("examIdChange", sessionStorage.getItem("examId"));
    }
    if (sessionStorage.getItem("unitId")) {
      this.$store.commit("unitIdChange", sessionStorage.getItem("unitId"));
    }
    if (sessionStorage.getItem("jobId")) {
      this.$store.commit("jobIdChange", sessionStorage.getItem("jobId"));
    }

    // if (sessionStorage.getItem("store")) {
    //   this.$store.commit(
    //     "stateChange",
    //     JSON.parse(sessionStorage.getItem("store"))
    //   );
    // }
    // 页面刷新前将store存入session
    window.addEventListener("beforeunload", () => {
      let params1 = this.$store.state.examId;
      let params2 = this.$store.state.unitId;
      let params3 = this.$store.state.jobId;
      sessionStorage.setItem("examId", params1);
      sessionStorage.setItem("unitId", params2);
      sessionStorage.setItem("jobId", params3);
    });
  },
  created() {},
  methods: {
    // 获取用户上网工具类型
    getWebTool() {
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";

      if (
        !(
          bIsIpad ||
          bIsIphoneOs ||
          bIsMidp ||
          bIsUc7 ||
          bIsUc ||
          bIsAndroid ||
          bIsCE ||
          bIsWM
        )
      ) {
        this.$store.commit("webToolChange", "web");
      } else if (bIsIpad) {
        this.$store.commit("webToolChange", "ipad");
      } else {
        this.$store.commit("webToolChange", "mobile");
      }
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue